/**
 * Shared Carousel Component
 * Handles all carousel/slideshow functionality across the site
 */

(function () {
    'use strict';

    function initializeCarousel(carouselElement) {
        if (!carouselElement) return;

        const images = carouselElement.querySelectorAll('.slideshow-image');
        const indicators = carouselElement.querySelectorAll('.indicator');
        const prevBtn = carouselElement.querySelector('.slideshow-btn.prev');
        const nextBtn = carouselElement.querySelector('.slideshow-btn.next');

        let thumbnails = [];
        const parent = carouselElement.closest('.product-gallery, .pilot-image, .product-showcase__media, .story-image, .service-gallery, .carousel-wrapper');
        if (parent) {
            thumbnails = parent.querySelectorAll('.thumbnail');
        }

        if (images.length <= 1) return;

        let currentIndex = 0;
        let autoSlideInterval;

        function showSlide(index) {
            images.forEach(img => img.classList.remove('active'));
            indicators.forEach(ind => ind.classList.remove('active'));
            thumbnails.forEach(thumb => thumb.classList.remove('active'));

            if (images[index]) images[index].classList.add('active');
            if (indicators[index]) indicators[index].classList.add('active');
            if (thumbnails[index]) thumbnails[index].classList.add('active');

            currentIndex = index;
        }

        function nextSlide() {
            const newIndex = (currentIndex + 1) % images.length;
            showSlide(newIndex);
        }

        function prevSlide() {
            const newIndex = (currentIndex - 1 + images.length) % images.length;
            showSlide(newIndex);
        }

        function startAutoSlide() {
            if (autoSlideInterval) {
                clearInterval(autoSlideInterval);
            }
            autoSlideInterval = setInterval(nextSlide, 5000);
        }

        function stopAutoSlide() {
            if (autoSlideInterval) {
                clearInterval(autoSlideInterval);
                autoSlideInterval = null;
            }
        }

        function resetAutoSlide() {
            stopAutoSlide();
            startAutoSlide();
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', () => {
                nextSlide();
                resetAutoSlide();
            });
        }

        if (prevBtn) {
            prevBtn.addEventListener('click', () => {
                prevSlide();
                resetAutoSlide();
            });
        }

        indicators.forEach((indicator, index) => {
            indicator.addEventListener('click', () => {
                showSlide(index);
                resetAutoSlide();
            });
        });

        thumbnails.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => {
                showSlide(index);
                resetAutoSlide();
            });
        });

        carouselElement.addEventListener('mouseenter', stopAutoSlide);
        carouselElement.addEventListener('mouseleave', () => {
            if (!autoSlideInterval) {
                startAutoSlide();
            }
        });

        startAutoSlide();
    }

    function initializeAllCarousels() {
        const carouselSelectors = [
            '.pilot-slideshow',
            '.service-slideshow',
            '.product-slideshow',
            '.image-slideshow',
            '.legacy-slideshow',
            '.balloon-slideshow',
            '.memory-slideshow'
        ];

        carouselSelectors.forEach(selector => {
            const carousels = document.querySelectorAll(selector);
            carousels.forEach(carousel => initializeCarousel(carousel));
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeAllCarousels);
    } else {
        initializeAllCarousels();
    }

    window.BananaCarousel = {
        init: initializeCarousel,
        initAll: initializeAllCarousels
    };
})();
